import React from 'react';
import ABSLinkCard, { LinkCard, LinkCardBG } from './ABSLinkCard';
import './index.less';
import { ABSModal } from '../ABSModal';
import ABSResolvePhoneOrMail from '../ABSResolvePhoneOrMail';
import ABSParagraph from '../ABSParagraph';

export interface IABSLinkCardListProps {
  list: LinkCard[];
  numberOfLines?: number;
}

class ABSLinkCardList extends React.Component<IABSLinkCardListProps> {
  menuModal;

  menuModalcontent() {
    return (
      <ABSParagraph>
        该功能仅对专业版用户开放，如果您有兴趣了解更多详情请与我们联系，电话：
        <ABSResolvePhoneOrMail />
        ，邮箱：
        <ABSResolvePhoneOrMail type="mail" />
        ，感谢您的关注与支持！
      </ABSParagraph>
    );
  } 

  onShowMenuModal = () => {
    this.menuModal.show( true );
  }

  renderList() {
    const { list } = this.props;
    return list.map((item, index) => {
      // 防止数组越界
      const indes = index % LinkCardBG.length;
      return <ABSLinkCard onShowMenuModal={this.onShowMenuModal} item={item} key={index} currentColor={LinkCardBG[indes]} />;
    });
  }

  render() {
    const { numberOfLines } = this.props;
    // 一个item的宽度是300px + 间距是12px, 显示
    const width = 218 * (numberOfLines ? numberOfLines : 3) + 12;
    return (
      <div className="abs-link-card-list" style={{ width }}>
        {this.renderList()}
        <ABSModal
          content={this.menuModalcontent()}
          width={360}
          footer={null}
          ref={view => this.menuModal = view}
        />
      </div>
    );
  }
}

export default ABSLinkCardList;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSLinkCardList/index.tsx